import s from "./dialogue-box.css";

export const styles = s;

export default `<div class="js-dialogue ${s["dialogue-box-wrapper"]}">
<div class="${s["dialogue-box"]}"></div>
</div>
`;
